import { Router as ReactRouter, Switch, Route, Redirect } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { ComponentType, FC, useMemo } from 'react';

import { routes as authRoutes } from '../modules/auth';
import { routes as dashboardRoutes } from '../modules/dashboard';
import { RouteProps, RoutePropsExtended } from '../types';

import PrivateRoute from './PrivateRouter';
import PublicRoute from './PublicRouter';

interface AllRoutesProps {
  routes: RouteProps[];
}

export const AllRoutes: FC<AllRoutesProps> = ({ routes }) => {
  return (
    <Switch>
      {routes.map(({ type, path, Component, ...rest }) => {
        let RouteComponent: ComponentType<RoutePropsExtended>;

        switch (type) {
          case 'Public':
            RouteComponent = PublicRoute;
            break;

          case 'Private':
            RouteComponent = PrivateRoute;
            break;

          default:
            RouteComponent = Route;
            break;
        }

        return <RouteComponent path={path} component={Component} key={path} {...rest} />;
      })}
      <Redirect from="*" to="/" />
    </Switch>
  );
};

const Router: FC = () => {
  const { routes } = useMemo(() => {
    const commonRoutes = [...authRoutes, ...dashboardRoutes];
    return {
      routes: commonRoutes,
    };
  }, []);

  const history = useMemo(() => createBrowserHistory(), []);

  return (
    <ReactRouter history={history}>
      <AllRoutes routes={routes} />
    </ReactRouter>
  );
};

export default Router;
